import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const Root = styled.section`
  width: 100%;
  ${(p) => responsive('padding', (typeof p.$paddingY === 'object' ? p.$paddingY : `${p.$paddingY || p.theme.layout?.section?.paddingY || '24px'} 0`), p.theme, (v) => `${v} 0`)}
`

export function Section({ children, paddingY, ...props }) {
  return (
    <Root $paddingY={paddingY} {...props}>
      {children}
    </Root>
  )
}
